import script from "./CreateAutoReplyDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateAutoReplyDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CreateAutoReplyDialog.vue?vue&type=style&index=0&id=803ad144&lang=sass"

const __exports__ = script;

export default __exports__